import i18next from 'i18next';
import { PromQuestionDto, PromQuestionLocalizedContentDto } from '../../../shared/dtos/prom.dto';

export function getSupportedLanguageCodes(): string[] {
  return Object.keys(i18next.options.resources ?? {});
}

export function getPromQuestionLocalizedContent(
  promQuestion: PromQuestionDto,
  languageCode: string,
): PromQuestionLocalizedContentDto | null {
  return promQuestion.localizeContent.find(
    (content: PromQuestionLocalizedContentDto) => content.languageCode === languageCode,
  ) ?? promQuestion.localizeContent[0] ?? null;
}
